var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9612 11.6356C13.6395 11.6356 15 10.2751 15 8.59688C15 6.91866 13.6395 5.55813 11.9612 5.55813H11.9442C11.9555 5.43301 11.9612 5.30629 11.9612 5.17829C11.9612 2.87068 10.0905 1 7.78296 1C5.47533 1 3.60464 2.87068 3.60464 5.17829C3.60464 5.18186 3.60465 5.1855 3.60466 5.18907C2.11854 5.49075 1 6.80463 1 8.37976C1 10.1779 2.45767 11.6356 4.2558 11.6356",
    fill: "#0260FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9612 11.6356C13.6395 11.6356 15 10.2751 15 8.59688C15 6.91866 13.6395 5.55813 11.9612 5.55813H11.9442C11.9555 5.43301 11.9612 5.30629 11.9612 5.17829C11.9612 2.87068 10.0905 1 7.78296 1C5.47533 1 3.60464 2.87068 3.60464 5.17829C3.60464 5.18186 3.60465 5.1855 3.60466 5.18907C2.11854 5.49075 1 6.80463 1 8.37976C1 10.1779 2.45767 11.6356 4.2558 11.6356",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16293 11.6354V7.83691V11.6354ZM8.16293 7.83691L9.68231 9.35629L8.16293 7.83691ZM8.16293 7.83691L6.64355 9.35629L8.16293 7.83691Z",
    fill: "#0260FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16293 11.6354V7.83691M8.16293 7.83691L9.68231 9.35629M8.16293 7.83691L6.64355 9.35629",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file_upload_icon.1b9fd3c79d2f33aafb55bc4c28b10f7e.svg";
export { ForwardRef as ReactComponent };